import CrossIcon from 'assets/img/cross.svg'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ReactSVG from 'react-svg'
import Logo from '../../assets/img/logo.svg'
import PlusLogo from '../../assets/img/plus-logo.svg'

export interface INativeProps {
  onScheduleCallClicked: () => void
  onClose: () => void
}

export interface IProps extends INativeProps, RouteComponentProps {}

class Content extends React.PureComponent<IProps> {
  render() {
    const { onClose, onScheduleCallClicked } = this.props
    return (
      <div>
        <div className="plus-container">
          <img className="logo-size" src={Logo} />
          <img className="plus-logo" src={PlusLogo} />

          <div className="congratulations-payment-tab design-fixes">
            <div className="title extra-bold">Congratulations!</div>
            <p>
              We’ve upgraded you completely{' '}
              <span className="pink-text extra-bold">free of charge</span>.
              Thank you for your vote of confidence in GiantLeap!
            </p>
            <p>
              Your credit card will <span className="underline">not</span> be
              charged and all available features will unlock in the next few
              minutes.
            </p>
            <p>
              Lastly, we’d love to schedule a call to get your feedback on how
              we can improve GiantLeap. Please pick a time that suits you best -
            </p>
            <div className="button-wrapper">
              <button
                className="explanation-submit-button"
                onClick={() => onScheduleCallClicked()}
              >
                Schedule call
              </button>
            </div>
          </div>
        </div>
        <div className="cross-icon" onClick={() => onClose()}>
          <ReactSVG src={CrossIcon} />
        </div>
      </div>
    )
  }
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/CongratulationsPayment/content.tsx